import React from 'react';
import { arrayOf, string, func, shape } from 'prop-types';
import { toKey } from '@/helpers/index';
import Caption from '@/components/typography/Caption';
import {
  SThemeFilters,
  SFilters,
  SFilterItem,
  SFilterLabel,
  SFilterInput,
} from './styles';

const ThemeFilters = ({ themes, updateFilters, applied }) => {
  return (
    <SThemeFilters data-testid="theme-filters">
      <Caption>Filter by category:</Caption>
      <SFilters>
        {themes.map((theme) => (
          <SFilterItem key={toKey(theme.name)}>
            <SFilterLabel
              color={theme.color}
              isChecked={applied.includes(theme.name)}
            >
              <SFilterInput
                data-testid={`theme-${theme.name}`}
                type="checkbox"
                id={toKey(theme.name)}
                onClick={(e) => updateFilters(e.target.id)}
              />
              {theme.title}
            </SFilterLabel>
          </SFilterItem>
        ))}
      </SFilters>
    </SThemeFilters>
  );
};

ThemeFilters.propTypes = {
  themes: arrayOf(
    shape({
      name: string,
      title: string,
      color: shape({
        main: string,
        light: string,
        dark: string,
      }),
    })
  ).isRequired,
  updateFilters: func.isRequired,
  applied: arrayOf(string).isRequired,
};

export default ThemeFilters;
